<header class="app-header" *ngIf="visible">
    <button type="button" class="home" (click)="goHome()" aria-label="Home">
        <svg class="home-icon" viewBox="0 0 20 20" aria-hidden="true">
            <path d="M2.5 9.5 10 3l7.5 6.5M4.5 8.2V16h11V8.2"
                  fill="none" stroke="currentColor" stroke-width="1.6"
                  stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span class="wordmark">Science Talent Network</span>
    </button>

    <button
        type="button"
        class="saved-searches-pill"
        data-testid="saved-searches-pill"
        aria-haspopup="dialog"
        (click)="openSavedSearches()">
        <svg viewBox="0 0 16 16" aria-hidden="true">
            <circle cx="8" cy="8" r="6.2" fill="none" stroke="currentColor" stroke-width="1.3" />
            <path d="M8 4.8V8l2.2 1.6" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
        </svg>
        <span>Saved Searches</span>
        <span class="badge" *ngIf="savedSearchCount > 0">{{ savedSearchBadge }}</span>
    </button>

    <div class="menu-anchor">
        <button
            type="button"
            class="menu-trigger"
            [class.open]="menuOpen"
            (click)="toggleMenu()"
            [attr.aria-expanded]="menuOpen"
            aria-haspopup="menu"
            aria-label="Menu">
            <svg class="dots" viewBox="0 0 20 20" aria-hidden="true">
                <circle cx="4" cy="10" r="1.6" fill="currentColor" />
                <circle cx="10" cy="10" r="1.6" fill="currentColor" />
                <circle cx="16" cy="10" r="1.6" fill="currentColor" />
            </svg>
        </button>

        <div class="popover" *ngIf="menuOpen" role="menu">
            <button type="button" class="menu-item" role="menuitem" (click)="goHome()">
                Home
            </button>
            <button
                type="button"
                class="menu-item"
                role="menuitem"
                data-testid="message-history-item"
                (click)="openMessageHistory()">
                Messages
            </button>
            <button
                type="button"
                class="menu-item"
                role="menuitem"
                *ngIf="isAdmin"
                (click)="goToDashboard()">
                Admin Dashboard
            </button>
            <hr class="divider" />
            <button
                type="button"
                class="menu-item"
                role="menuitem"
                *ngIf="hostAdapter.CanReturnToHost"
                (click)="returnToHost()"
            >
                Back to Explorer
            </button>
            <button type="button" class="menu-item danger" role="menuitem" (click)="signOut()">
                Sign out
            </button>
        </div>
    </div>
</header>

<!-- Hosted here (not in the host apps) so both hosts get it for free — the
     native dialog renders in the top layer regardless of this position. It
     renders nothing until the kebab menu's Messages item opens it. -->
<maps-message-history-drawer></maps-message-history-drawer>
